import axios from 'axios'

export default {
    addEntityView(entityViewRequest) {
        return axios.post(window.API_BASE + '/api/v1/EntityViews', entityViewRequest)
    }
}